module.exports = __webpack_public_path__ + "static/media/icon-text.b7bebf28.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/icon-text.svg
 ** module id = 367
 ** module chunks = 0
 **/